import React from 'react';
import { useSelector } from 'react-redux';
import {
    DashboardMainChartsGrid,
    DashboardMainSkeleton,
    DashboardMainDrawer,
    DashboardMainSummaryCards,
    DashboardMainVariationCards,
} from './components';
import { useHomeDashboard } from './hooks';

export const DashboardMainScreen = () => {
    const { token } = useSelector((state) => state.auth);

    const {
        isLoading,
        isBusy,
        error,
        dashboard,
        days,
        setDays,
        customerId,
        setCustomerId,
        projectId,
        setProjectId,
        dateFrom,
        setDateFrom,
        dateTo,
        setDateTo,
        isFiltersDrawerOpen,
        setIsFiltersDrawerOpen,
        quickRangeOptions,
        customerOptions,
        projectOptions,
        hasActiveFilters,
        trendSeries,
        trendPoints,
        statusTotal,
        priorityTotal,
        typeTotal,
        variationTickets,
        variationOpen,
        variationClosed,
        formatNumber,
        formatVariation,
        variationClass,
        handleClearFilters,
        loadDashboard,
    } = useHomeDashboard({ token });

    return (
        <div className="row">
            <div className="col-12">
                <div className="card stretch stretch-full card__no-border">
                    <div className="card-body">
                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
                            <div>
                                <h4 className="mb-1">Dashboard general</h4>
                                <p className="text-muted mb-0 fs-12">Resumen ejecutivo de operación, carga y tendencias de tickets.</p>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                {hasActiveFilters && <span className="badge bg-soft-warning text-warning">Filtros activos</span>}
                                <button
                                    type="button"
                                    className="btn btn-sm btn-light-brand"
                                    onClick={() => setIsFiltersDrawerOpen(true)}
                                    disabled={isBusy}
                                >
                                    <i className="feather-sliders me-1" />
                                    Filtros
                                </button>
                            </div>
                        </div>

                        <DashboardMainDrawer
                            isOpen={isFiltersDrawerOpen}
                            onClose={() => setIsFiltersDrawerOpen(false)}
                            days={days}
                            quickRangeOptions={quickRangeOptions}
                            onDaysChange={setDays}
                            dateFrom={dateFrom}
                            dateTo={dateTo}
                            onDateFromChange={setDateFrom}
                            onDateToChange={setDateTo}
                            customerId={customerId}
                            customerOptions={customerOptions}
                            onCustomerChange={setCustomerId}
                            projectId={projectId}
                            projectOptions={projectOptions}
                            onProjectChange={setProjectId}
                            onApply={loadDashboard}
                            onClear={handleClearFilters}
                            isLoading={isBusy}
                        />

                        {error && <div className="alert alert-danger py-2 mb-3">{error}</div>}

                        {isLoading && <DashboardMainSkeleton />}

                        {!isLoading && (
                            <>
                                <DashboardMainSummaryCards summary={dashboard?.summary} formatNumber={formatNumber} />
                                <DashboardMainVariationCards
                                    summary={dashboard?.summary}
                                    previousSummary={dashboard?.previousSummary}
                                    variationTickets={variationTickets}
                                    variationOpen={variationOpen}
                                    variationClosed={variationClosed}
                                    formatNumber={formatNumber}
                                    formatVariation={formatVariation}
                                    variationClass={variationClass}
                                />
                                <DashboardMainChartsGrid
                                    dashboard={dashboard}
                                    trendSeries={trendSeries}
                                    trendPoints={trendPoints}
                                    statusTotal={statusTotal}
                                    priorityTotal={priorityTotal}
                                    typeTotal={typeTotal}
                                    formatNumber={formatNumber}
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export const HomeScreen = DashboardMainScreen;
